import { HuntGroupDisplay } from './HuntGroupDisplay'
import { HuntGroupForm } from './HuntGroupForm.container'
import IconPhoneTalk from 'components/Icons/PhoneTalk'
import IconPhoneForward from 'components/Icons/PhoneForward'
import IconPhoneMissed from 'components/Icons/PhoneMissed'
import IconPhoneHangup from 'components/Icons/PhoneHangup'
import { getNumberType } from '../../utils/getNumberType'
import { get } from 'lodash'

export default {
  id: 'hunt_group',
  label: 'Forward to hunt group',
  helpUrl: 'https://help.thinkpickle.com.au/flows/actions/hunt-group',
  icon: IconPhoneForward,
  inputs: [{}],
  outputs: [
    {
      name: 'call-forwarded',
      label: 'If the called party pick up (call forwarded successfully).',
      icon: IconPhoneTalk,
    },
    {
      name: 'call-busy-no-answer',
      label:
        "If the called party is busy or does not answer (this can be controlled with 'timeout'). Note, phones with voicemail may not work.",
      icon: IconPhoneMissed,
    },
  ],
  display: HuntGroupDisplay,
  form: HuntGroupForm,
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/HuntGroup/index.js